import {Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../../interfaces/dialog/dialog-params';
import {PostbackLogService} from '../../../../../../services/postback/postback-log.service';
import {PostbackLog} from '../../../../../../models/postback/postback-log';
import {Postback} from '../../../../../../models/postback/postback';
import {FormsModule} from '@angular/forms';
import {DateRangeSelectorComponent} from '../../../../../layout/date-range-selector/date-range-selector.component';
import {DateRange} from '../../../../../../types/date-range';
import {ParisDatePipe} from '../../../../../../pipes/date/paris-date.pipe';
import {PaginatorComponent} from '../../../../../layout/paginator/paginator.component';
import {TableSorterHeaderDirective} from '../../../../../../directives/table-sorter/table-sorter-header.directive';
import {Paginator} from '../../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../../tools/table-sorter/table-sorter';
import {TableSorterDirective} from '../../../../../../directives/table-sorter/table-sorter.directive';

@Component({
  selector: 'app-partner-postback-log',
  imports: [
    FormsModule,
    DateRangeSelectorComponent,
    ParisDatePipe,
    PaginatorComponent,
    TableSorterHeaderDirective,
    TableSorterDirective
],
  templateUrl: './partner-postback-log.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-postback-log.component.scss'
})
export class PartnerPostbackLogComponent implements Dialog {

  protected postback!: Postback;
  protected logs: PostbackLog[] = [];

  status: string = '';
  dateRange: DateRange | null = null;

  @ViewChild(DateRangeSelectorComponent) dateSelector!: DateRangeSelectorComponent;

  paginator = new Paginator(5);
  tableSorter: TableSorter = new TableSorter('createdAt', 'desc');

  constructor(
    private postbackLogService: PostbackLogService
  ) {
  }

  onDialogInit(params: DialogParams): void {
    params.class = 'full-width';
    this.postback = params.data.postback;

    // The first fetch is normally triggered by the initial dateChanged emission
    // of the date-range-selector; fetch here only if it already fired
    if (this.dateRange) {
      this.fetchAll();
    }
  }

  updateRange(dateRange: DateRange): void {
    this.dateRange = dateRange;
    this.onFilterChange();
  }

  onFilterChange(): void {
    this.paginator.reset();
    this.fetchAll();
  }

  fetchAll(): void {
    if (!this.postback) {
      return;
    }

    const parameters: any = {postbackId: this.postback.id};

    if (this.dateRange) {
      parameters.startDate = this.dateSelector ? this.dateSelector.getDateISO8601From() : this.dateRange.start.toISOString();
      parameters.endDate = this.dateSelector ? this.dateSelector.getDateISO8601To() : this.dateRange.end.toISOString();
    }
    if (this.status) {
      parameters.status = this.status;
    }

    this.postbackLogService.findAll(parameters, this.paginator, this.tableSorter).subscribe((logs: PostbackLog[]) => {
      this.logs = logs;
    });
  }
}
